var render = function render(){var _vm=this,_c=_vm._self._c;return _c('FormaPagamentoManage',{attrs:{"idFrom":_vm.$route.params.id != undefined ? +_vm.$route.params.id : 0},on:{"saved":function($event){return _vm.redirectToList()},"voltar":function($event){return _vm.$router.push({ name: 'des-forma-pagamento-list' })}}})
}
var staticRenderFns = []

export { render, staticRenderFns }